import { Injectable, NgModule } from '@angular/core';
import { Routes, RouterModule, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { catchError } from 'rxjs/operators';
import { forkJoin, Observable, of } from 'rxjs';

import { CompaniesMainComponent } from './containers/companies-main/companies-main.component';
import { CompanyMainComponent } from './containers/company-main/company-main.component';
import {
  // CompanyOverviewComponent,
  // CompanyUsersComponent,
  // CompanyTrialKitComponent,
  // CompanyQueuesComponent,
  // CompanyEquipmentComponent,
  // CompanyReviewsComponent,
  // CompanySupportDevicesComponent,
  CompanyConnectivityOverviewComponent,
  CompanyConnectivityEquipmentComponent,
  CompanyConnectivityDetailsMainComponent,
} from './components';
import { ConnectivityService } from 'src/app/domains/connectivity/services/connectivity.service';
import { CompanyService } from 'src/app/domains/companies/services';
import { ConnectionDetails } from 'src/app/domains/connectivity/models/connectivity.model';
import { Company } from 'src/app/domains/companies/models';


@Injectable()
class ConnectivityResolver {
  constructor(
    private connectivityService: ConnectivityService,
    private companyService: CompanyService,
    private router: Router
  ) {}

  resolve(route: ActivatedRouteSnapshot): Observable<{connection: ConnectionDetails, company: Company}>|Promise<{connection: ConnectionDetails, company: Company}>|{connection: ConnectionDetails, company: Company} {
    const connection$ = this.connectivityService
      .getConnection(parseInt(route.paramMap.get('connectionID')))
      .pipe(catchError(() => of(null)));

    if (this.router.getCurrentNavigation().extras?.state) {
      const state = this.router.getCurrentNavigation().extras.state;
      return forkJoin({
        connection: connection$,
        company: of(state.company)
      });
    } else
    return forkJoin({
      connection: connection$,
      company: this.companyService
        .getCompany(parseInt(route.parent.paramMap.get('id')))
        .pipe(catchError(() => of(null)))
    })
  }
}

const routes: Routes = [
  { path: '', component: CompaniesMainComponent },
  { path: ':id', redirectTo: ':id/overview', },
  { path: ':id/overview', component: CompanyMainComponent },
  { path: ':id/users', component: CompanyMainComponent },
  { path: ':id/dids', component: CompanyMainComponent },
  { path: ':id/fax', component: CompanyMainComponent },
  { path: ':id/dids', component: CompanyMainComponent },
  { path: ':id/queues', component: CompanyMainComponent },
  { path: ':id/trial-kit', component: CompanyMainComponent },
  { path: ':id/equipment', component: CompanyMainComponent },
  { path: ':id/integrations', component: CompanyMainComponent },
  { path: ':id/sms', component: CompanyMainComponent },
  { path: ':id/equipment/:mac', component: CompanyMainComponent },
  { path: ':id/connectivity', component: CompanyMainComponent,
    children: [
      { path: ':connectionID',
        component: CompanyConnectivityDetailsMainComponent,
        resolve: {
          resolved: ConnectivityResolver
        },
        children: [
          { path: 'overview', component: CompanyConnectivityOverviewComponent },
          { path: 'equipment', component: CompanyConnectivityEquipmentComponent },
          { path: '', redirectTo: 'overview', pathMatch: 'full' }
        ]
      }
    ]
  },
  { path: ':id/reviews', component: CompanyMainComponent },
  { path: ':id/support-devices', component: CompanyMainComponent }
  // TODO: find better way to navigate with company child routes below:
  // children: [
  //   { path: '', redirectTo: 'overview', pathMatch: 'full'},
  //   { path: 'overview', component: CompanyOverviewComponent, outlet: 'company' },
  //   { path: 'users', component: CompanyUsersComponent, outlet: 'company' },
  //   { path: 'trial-kit', component: CompanyTrialKitComponent, outlet: 'company' },
  //   { path: 'queues', component: CompanyQueuesComponent, outlet: 'company' },
  //   { path: 'equipment', component: CompanyEquipmentComponent,outlet: 'company' },
  //   { path: ':id/equipment/:mac', component: CompanyMainComponent },
  //   { path: 'support-devices', component: CompanySupportDevicesComponent, outlet: 'company' }
  // ]
];


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [ConnectivityResolver]
})
export class CompaniesRoutingModule { }
